import axios from 'axios'

export default {
  // 全部渠道
  getChannel(roleType) {
    return axios.get('channel/get_channel_source_select_by_role',{
      params:{
        role:roleType
      }
    })
  },

  getContact(){
    return axios.get('channel/get_all_channel')
  },

  // 拍摄地
  getShop() {
    return axios.get('shop/get_show_shop_list')
  },

  // 全部人员
  getStaff(roleType) {
    return axios.get('group/get_group_staff_by_role',{
      params:{
        role:roleType
      }
    })
  },

  //全部客服
  getService(){
    return axios.get('group/get_dsyy_group_staff_list')
  },

  //全部客服
  getServiceAllot(role){
    return axios.get('group/get_online_staff_list_by_role',{params:{role:role}})
  },

  //分配客服
  getServiceCustomAllot(role){
    return axios.get('group/get_all_group_staff_by_role',{params:{role:role}})
  },

  //意向等级
  getYxlive(){
    return axios.get('dictionary/get_yx_level_list')
  },

  //录入客资
  getEntryKz(roleType){
    return axios.get('channel/get_channel_source_by_role_on_add',{
      params:{
        role:roleType
      }
    })
  },

  //拍摄类型
  getShotType(){
    return axios.get('dictionary/get_common_type_list')
  },

  //咨询类型
  getZxStyle(){
    return axios.get('dictionary/get_zx_style_list')
  },
}



// WEBPACK FOOTER //
// ./src/api/condition-tree-data.js